function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    display: inline-block;\n    margin-top: ", ";\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n            margin-bottom: ", ";\n          "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n            margin-right: ", ";\n          "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    align-items: center;\n    background-color: #3d7ab7;\n    border-radius: 10px;\n    box-sizing: border-box;\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    padding: ", ";\n    width: ", ";\n\n    &:not(:last-child) {\n      ", "\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React, { forwardRef, useCallback } from "react";
import styled, { css } from "styled-components";
import { Icon } from "@cf-design-system/icon";
var MenuItemWrapper = styled.div((_ref) => {
  var {
    orientation,
    theme,
    width
  } = _ref;
  return css(_templateObject(), theme.spaceUnit.xs, "".concat(width, "%"), orientation === "horizontal" ? css(_templateObject2(), theme.spaceUnit.xs) : css(_templateObject3(), theme.spaceUnit.xs));
});
var MenuItemTitle = styled.span((_ref2) => {
  var {
    theme
  } = _ref2;
  return css(_templateObject4(), theme.spaceUnit.xxs);
});

var MenuItem = (_ref3, ref) => {
  var {
    icon,
    label,
    orientation = "horizontal",
    width = 100,
    onClick
  } = _ref3;
  var onClickItem = useCallback(() => {
    var _current;

    ref === null || ref === void 0 ? void 0 : (_current = ref.current) === null || _current === void 0 ? void 0 : _current.hide();
    onClick();
  }, [onClick, ref]);
  return /*#__PURE__*/React.createElement(MenuItemWrapper, {
    orientation: orientation,
    width: width,
    onClick: onClickItem
  }, /*#__PURE__*/React.createElement(Icon, {
    frameColor: "#0b5fb4",
    hasFrame: true,
    name: icon,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement(MenuItemTitle, null, typeof label === "string" ? label : label()));
};

export default /*#__PURE__*/forwardRef(MenuItem);